<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{ year }}
    Rubbermaid Commercial Products</strong>.
  </footer>
</template>

<script>
export default {
  name: 'UserDashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserDashFooter.vue?45eac26b